<div class="map-container" #mapcontainer>

  <div class="listing-section desktop" #listingsection>
   
    <app-property-search-listing 
    (onlistinghovered)="onListingHovered($event)"
    [isModalCanceled]="favoriteReturn"
      (isFavourite)="toggleFavouriteProperty($event)" 
      *ngFor="let listing of listings; let i = index" [listing]="listing">
    </app-property-search-listing>
  </div>

  <div class="content" id="content">
    <app-property-search-popup *ngIf="popupFlag" (closePopup)="closeListingPopup()" [listing]="selectedListing">
    </app-property-search-popup>
  </div>

  <div class="map-control-container" [ngClass]="{'offsetTop': offsetMap}">
    <!-- <div class="d-flex align-items-center search-flag">
      <input [checked]="searchMapFlag" name="search_map" id="search_map" (change)="toggleMapSearch()"
        class="form-check-input" type="checkbox">
      <label class="ms-2" for="search_map"> Search as I move the map</label>
    </div> -->
    <div #map class="map" [id]="id">
    </div>
     <div *ngIf="!listings.length" class="col-md-6 offset-md-3 text-center empty-state">
      <div><img src="/assets/icons/location-search.svg" alt="icon"></div>
      <div class="newsletter">
        <div class="mb-4">
          <h6 class="text-f20-bold text-center">Sorry, no available properties have been found.</h6>
          <div class="my-4 d-flex justify-content-center align-items-center">
            <span class="line w-25">&nbsp;</span>
          </div>

        </div>
      </div>
    </div> 
  </div>

  <div class="listing-section mobile" #listingsectionmobile>
    <app-property-search-listing [isMobile]="true" [listing]="selectedListing"
    (isFavourite)="toggleFavouriteProperty($event)"
      (onlistinghovered)="onListingHovered($event)" [selectedListing]="true">
    </app-property-search-listing>
  </div>

  <div class="w-100 mobile  more-section">
    <div class="h-line mt-0"></div>
    <div (click)="showMore.emit()" class="d-flex text-pry pointer align-items-center">
      {{count ? count-1 + "+" : ""}} more properties
    </div>

  </div>

</div>
